import { translateText } from '@alexis/helpers/translation';

import { isDateValid } from '@helpers/flights/date';

import { Translations } from '@wegoTypes/translations';

export const validateExpiryDate = (value: string, translations: Translations, locale: string) => {
  if (!value) return true;
  if (!isDateValid(value))
    return translateText(translations.invalid, locale, translations.date_of_expiry as string);
  const [day, month, year] = value.split('/').map(Number);
  const expiryDate = new Date(year, month - 1, day);

  const sixMonthsFromNow = new Date();
  sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);

  return expiryDate > sixMonthsFromNow || (translations.travel_doc_6_months as string);
};

export const validateDateOfBirth = (
  value: string,
  isPrimary: boolean = true,
  translations: Translations,
  locale: string,
) => {
  if (!value) return true;
  if (!isDateValid(value))
    return translateText(translations.invalid, locale, translations.date_of_birth as string);

  const [day, month, year] = value.split('/').map(Number);
  const dateOfBirth = new Date(year, month - 1, day);
  const today = new Date();

  let age = today.getFullYear() - dateOfBirth.getFullYear();
  const monthDiff = today.getMonth() - dateOfBirth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dateOfBirth.getDate())) {
    age--;
  }

  // max age limit 130 years
  if (age > 130) {
    return translateText(translations.invalid, locale, translations.date_of_birth as string);
  }

  // min age
  if (isPrimary) {
    // 12 years for primary travelers
    if (age < 12) {
      return translateText(translations.invalid, locale, translations.date_of_birth as string);
    }
  } else {
    // 7 days for non-primary travelers
    const msDiff = today.getTime() - dateOfBirth.getTime();
    const daysDiff = msDiff / (1000 * 60 * 60 * 24);
    if (daysDiff < 7) {
      return translateText(translations.invalid, locale, translations.date_of_birth as string);
    }
  }

  return true;
};

export const formatDateForDisplay = (date?: string | null): string => {
  if (!date) return '';
  if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  }

  return date;
};

export const formatDateForApi = (date?: string | null): string => {
  if (!date) return '';
  if (date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const [day, month, year] = date.split('/');
    return `${year}-${month}-${day}`;
  }
  return date;
};
